import { CommandBase } from '@shared/commands/command-base';
import { NotificationsConfig } from '../notifications-config';

export class DeleteAlertsCommand extends CommandBase {
  constructor (public subscriptionIds: string[]) {
    super(NotificationsConfig.getDeleteAlertsApi);
    this.projectId = '[PROJECT_ID]';
  }
}

export class ToggleStateCommand extends CommandBase {
  constructor (public subscriptionId: string, public isActive: boolean) {
    super(NotificationsConfig.getUpdateSubscriptionStateApi);
    this.projectId = '[PROJECT_ID]';
  }
}
